<template>
    <div style="height: 70vh;overflow: auto;">
        <!-- <div>可用文件夹数量上限：  <Tag color="success">{{max}} 个</Tag>，已用：<Tag color="warning">{{folderNumbersUsed}} 个</Tag></div> -->
        <div>
            <div style="height: 20px;line-height: 20px;display: block;padding-left: 5px;font-size: 14px;">
                文件夹数 {{folderNumbersUsed}} / {{max}}
                <!-- <span style="float: right;padding-right: 5px;">升级至专业版</span> -->
                <!-- <Button type="text" size="small" style="box-shadow: none;float: right;padding-right: 5px;">
                    升级至专业版
                </Button> -->
            </div>
            <Progress :percent="parseInt((folderNumbersUsed/max)*100)" :stroke-width="20" text-inside style="overflow-x: hidden;">
            </Progress>
        </div>
        <Tree id="maintree" ref="tree1" :select-node=false :data="data5" :render="renderContent" @on-select-change="selectitem"></Tree>
    </div>
</template>
<script type="text/javascript">
import { mapActions, mapGetters } from 'vuex'
import menu from './dropdownmenu.vue'
import store from '../../store'
import constJson from '../../api/common/constjson.js'
let constJ = new constJson()
export default {
    name: 'document_tree',
    // inject: ["ffiles"],
    components: {},
    provide() {
        return {
            addChild: this.append,
            removeNode: this.remove,
            editNode: this.edit,
            moveNode: this.moveNode,
            totalFiles: this.getTotalFiles,
        }
    },
    data() {
        return {
            selectKey: 0,
            //data5: store.state.user.myfolders,
            data5: [],
            folderNumbersUsed: 0, //已经使用的文件夹
            filesInFolder: 0,
            totalFolders: 0,
        }
    },
    computed: {
        ...mapGetters(['sta']),
        max: function() {
            let maxFolderNums = 0
            let code = this.$Tools.getPermission().CODE_FUNC_FOLDER
            let permission = this.sta.permission
            if (permission && permission.length > 0) {
                let element = permission.find(p => p.f === code)
                maxFolderNums = element.n
            }
            return maxFolderNums;
        },
    },
    created() {
        console.log('docfolder.created===>')
        this.getFolderTree()
        this.calcFolderTotal()
    },
    methods: {
        //递归计算文件数量
        recursionCalcFolders(data) {
            for (let index = 0; index < data.length; index += 1) {
                if (data[index].value !== '') {
                    this.totalFolders += 1
                }
                if (data[index].children instanceof Array && data[index].children.length > 0) {
                    this.recursionCalcFolders(data[index].children);
                }
            }
        },
        calcFolderTotal() {
            let folders = store.state.user.myfolders
            //console.log(folders)
            this.recursionCalcFolders(folders)
            console.log('calcFolderTotal:' + this.totalFolders)
            this.folderNumbersUsed = this.totalFolders - 1
        },
        getTotalFiles() {
            return this.filesInFolder
        },
        setTotalFiles(total) {
            this.filesInFolder = total
        },
        getFolderMax() {

        },
        //获取文件夹权限参数
        getPermission(code) {
            //"000014" // 普通下载
            let rsp = {}
            let checkcode = code
            let permission = this.sta.permission
            if (permission && permission.length > 0) {
                let element = permission.find(p => p.f === checkcode)
                rsp = element
            }
            return rsp
        },
        //移动文件夹
        moveFolder(root, node, data, destinationNode) {
            // console.log(data)
            // console.log(destinationNode)
            let destination = {
                dir_id: data.value,
                new_parent_dir_id: destinationNode.node.value
            }
            console.log(destination)
            constJ.reqFolderMove(destination).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //更新视图
                        const children = destinationNode.node.children || []
                        console.log("children===>", children)
                        children.push(data)
                        this.$set(destinationNode.node, 'children', children);
                        //remove，更新视图
                        const parentKey = root.find(el => el === node).parent;
                        const parent = root.find(el => el.nodeKey === parentKey).node;
                        const index = parent.children.indexOf(data);
                        parent.children.splice(index, 1);
                        this.commitData()

                        this.$Message.success('文件夹移动成功。')
                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })

        },
        //重命名文件夹
        renameFolder(data,new_title) {
            let newName = {
                dir_id: data.value,
                new_dir_name: new_title
            }
            console.log('renameFolder==>')
            console.log(newName)
            constJ.reqFolderRename(newName).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$set(data, 'title', new_title);
                        //更新数据
                        this.commitData()
                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })
        },
        //删除文件夹
        deleteFolder(root, node, data) {
            // console.log(root)
            // console.log(node)
            //console.log(data)
            let folder = {
                dir_id: data.value,
            }
            console.log(folder)
            constJ.reqFolderDelete(folder).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //更新视图
                        const parentKey = root.find(el => el === node).parent;
                        const parent = root.find(el => el.nodeKey === parentKey).node;
                        const index = parent.children.indexOf(data);
                        parent.children.splice(index, 1);
                        //更新数据
                        this.commitData()
                        //更新文件夹计数器
                        // this.folderNumbersUsed-=1
                        this.totalFolders = 0 //初始化文件夹计数器
                        this.calcFolderTotal() //递归计算文件夹数量
                        //刷新上传文件列表
                        this.$emit('on-folder-delete', '')
                        this.$Message.success('文件夹：' + data.title + ' 删除成功。')
                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })
        },
        //判断创建文件夹数量是否超出产品配置的上限,
        //超过返回false，未超过返回true
        chenckAddFolderPermission() {
            console.log(this.folderNumbersUsed)
            let rsp = {
                rlt: false,
                fc: null,
            }
            let code = this.$Tools.getPermission().CODE_FUNC_FOLDER
            let func = this.getPermission(code)
            if (this.folderNumbersUsed < func.n) {
                rsp.rlt = true
                rsp.fc = func
            } else {
                rsp.fc = func
            }
            return rsp
        },
        //新增文件夹
        addFolder(parent, child) {
            //console.log(parent,child)
            /////////**********检查文件夹权限,测试期放开，上线启用*************************
            let checkRsp = this.chenckAddFolderPermission()
            console.log(checkRsp)
            // console.log(!checkRsp.rlt)
            if (!checkRsp.rlt) {
                this.$Message.warning('新建文件夹失败：超过上限数量：' + checkRsp.fc.n + '个')
                return
            }
            /////////////************************************************************
            //处理正常逻辑
            let folder = {
                parent_dir_id: parent.value,
                dir_name: child.title,
            }
            constJ.reqFolderCreate(folder).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        let folderId = ''
                        if (res.data && res.data.dirid) {
                            folderId = res.data.dirid
                            //更新UI
                            const children = parent.children || [];
                            //更新folderid,parentid
                            child.value = folderId
                            children.push(child)
                            this.$set(parent, 'children', children);
                            //更新数据
                            this.commitData()
                            //叠加文件夹计数器
                            this.folderNumbersUsed += 1
                            this.$Message.success('文件夹：' + child.title + ' 创建成功。')
                        } else {
                            this.$Message.warning('新建文件夹失败：' + res.data.dirid)
                            return
                        }

                    } else {
                        this.$Message.warning('新建文件夹失败：' + res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning('新建文件夹异常:' + res.rtncode)
                    return
                }

            })
        },
        //修改key
        changeTreeDate(jsonObj, newKey, oldKey) {
            let str = JSON.stringify(jsonObj);
            let reg = new RegExp(oldKey, 'g');
            let newStr = str.replace(reg, newKey);
            return JSON.parse(newStr);
        },
        //递归增加expand,_select,默认为false
        addAttribute(childrens) {
            childrens.forEach(item => {
                if (item.is_root) {
                    //展开第一层
                    item.expand = true
                    item._select = false
                } else {
                    item.expand = false
                    item._select = false
                }

                if (item.children && item.children.length > 0) {
                    this.addAttribute(item.children)
                }
            })
        },
        //获取文件夹树
        getFolderTree() {
            constJ.reqGetFolderTree().then(res => {
                console.log('getFolderTree==>')
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //修改根节点
                        if (res.data.tree.is_root) {
                            res.data.tree.dir_name = '全部文件归档'
                        }
                        this.folderNumbersUsed = res.data.numberoffolders
                        var data = []
                        data.push(res.data.tree)
                        //处理数据1，修改key name：title，value
                        let data_tree = this.changeTreeDate(data, 'title', 'dir_name')
                        data_tree = this.changeTreeDate(data_tree, 'value', 'dir_id')
                        this.data5 = data_tree
                        //递归增加属性expand，_select
                        this.addAttribute(this.data5)
                        var str = JSON.stringify(this.data5)
                        this.data5 = JSON.parse(str)
                        //更新数据
                        this.commitData()
                    }
                }
            })
        },
        selectitem(value) {
            if (value.length > 0) {
                console.log(value)
                this.selectKey = value[0].nodeKey
            }

        },
        //递归选中
        recursionGet(setValues, valueId) {
            let value = null;
            for (let index = 0; index < setValues.length; index += 1) {
                if (setValues[index].value === valueId) {
                    setValues[index]._select = true
                    value = setValues[index];
                    //break;
                } else {
                    setValues[index]._select = false
                }
                if (setValues[index].children instanceof Array && setValues[index].children.length > 0) {
                    const text = this.recursionGet(setValues[index].children, valueId);
                    //if (text)
                    //return text;
                }
            }
            //return value;
        },
        //递归查找文件夹以及子文件夹，没有找到返回null
        recursion(setValues, valueId) {
            let value = null;
            for (let index = 0; index < setValues.length; index += 1) {
                if (setValues[index].value === valueId) {
                    value = setValues[index];
                    break;
                }
                if (setValues[index].children instanceof Array && setValues[index].children.length > 0) {
                    const text = this.recursion(setValues[index].children, valueId);
                    if (text)
                        return text;
                }
            }
            return value;
        },
        setTreeData(node) {
            let n = node.node
            console.log(n)
            // console.log(this.data5)
            let d = this.recursionGet(this.data5, n.value)
            this.$emit('on-folder-open', n)
            //console.log(this.data5)
        },
        renderContent(h, { root, node, data }) {
            // console.log('render==>')
            // console.log(data)
            return h('span', {
                style: {
                    display: 'inline-block',
                    cursor: "pointer",
                    width: '100%',
                    backgroundColor: node.node._select ? "#D5E8FC" : "#fff",
                    height: '24px',
                    lineHeight: '24px',
                    //padding: '0 4px',
                    paddingLeft: '5px',
                    borderRadius: '4px',
                    color: data.is_fixed ? '#2b85e4' : '#17233d',
                    //transition: 'all .2s ease-in-out',
                },
                on: {
                    click: (e) => {
                        this.setTreeData(node)

                    }
                }
            }, [
                h('span', [
                    h('Icon', {
                        props: {
                            type: 'md-folder',
                            color: '#ECC12B',
                            size: '16'
                        },
                        style: {
                            marginRight: '8px',
                        }
                    }),
                    h('span', data.title)
                ]),
                h('span', {
                    style: {
                        display: 'inline-block',
                        float: 'right',
                        //marginRight: '32px'
                    }
                }, [
                    h(menu, {
                        props: {
                            root: root,
                            node: node,
                            nodeData: data,
                            rawData: store.state.user.myfolders,
                            isShowDel: node.node.nodeKey === 0 || data.is_fixed ? false : true,
                            isShowEdit: node.node.nodeKey === 0 ? false : true,
                            isShowSelecter: node.node.nodeKey === 0 || data.is_fixed ? false : true,
                        },
                        style: {
                            //marginRight: '8px',
                            display: node.node._select ? 'inline-block' : 'none',
                            //backgroundColor: 'green'
                        },
                        on: {
                            click: (e) => {}
                        }
                    }),
                ])
            ]);
        },
        //更新
        commitData() {
            store.state.user.myfolders = this.data5
        },
        append(data, child) {
            console.log(data, child)
            //创建
            this.addFolder(data, child)

            // this.$set(data, 'children', children);
            // console.log(this.data5)
            // this.commitData()
        },
        moveNode(root, node, data, dst) {

            //判断是否可以移动，不能移动到自身文件夹及子文件夹下
            console.log('movenode====>')
            console.log(dst)
            if(dst&&dst.length===0){
                this.$Message.warning('请选择全部文件归档下的文件夹。')
                return
            }
            let destinationNode = root.find(el => el.node.value === dst.value)
            let arrays = []
            arrays.push(data)
            console.log('ready to move node====>', destinationNode)
            console.log(arrays)
            let isExistFolder = this.recursion(arrays, destinationNode.node.value)
            console.log(isExistFolder)
            if (!isExistFolder) {
                this.moveFolder(root, node, data, destinationNode)
                // const children = destinationNode.node.children || []
                // console.log("children===>", children)
                // children.push(data)
                // this.$set(destinationNode.node, 'children', children);
                // //remove
                // this.remove(root, node, data)
                // this.commitData()
            } else {
                this.$Message.warning('不能将文件移动到自身或其子目录下')
                return
            }
        },
        remove(root, node, data) {
            this.deleteFolder(root, node, data)
            // const parentKey = root.find(el => el === node).parent;
            // const parent = root.find(el => el.nodeKey === parentKey).node;
            // const index = parent.children.indexOf(data);
            // parent.children.splice(index, 1);
            // this.commitData()
        },
        removeWhenMoveFolder() {

        },
        edit(data,new_title) {
            this.renameFolder(data,new_title)
            // this.$set(data, 'title', data.title);
            // this.commitData()
        },
    }
}
</script>
<style lang="less" scoped>
#maintree/deep/ .ivu-tree-title {
    //width: 90%;
    padding: 0;
    border-radius: 5px;
    word-break: break-all;
}
</style>